export default function MySQL_REPEAT() {
  return (
    <div>
      <h2>MySQL_REPEAT</h2>    </div>
  );
}